import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../mutators";
import { Layout } from "../../utilities/Constants";

export interface LayoutState {
    sidebar: Sidebar;
    isMobile: boolean;
}

export interface Sidebar {
    open: boolean;
}

const initialState: LayoutState = {
    sidebar: {
        open:
            window.innerWidth > Layout.MOBILE_VIEWPORT_WIDTH &&
            window.innerHeight > Layout.MOBILE_VIEWPORT_HEIGHT,
    },
    isMobile:
        window.innerWidth <= Layout.MOBILE_VIEWPORT_WIDTH ||
        window.innerHeight <= Layout.MOBILE_VIEWPORT_HEIGHT,
};

export const CoreSlice = createSlice({
    name: "core",
    initialState,
    reducers: {
        // Toggle state.
        TOGGLE_SIDEBAR_MENU: (state) => {
            state.sidebar.open = !state.sidebar.open;
        },
        // Reset state.
        RESET: (state) => {
            reset(state, initialState);
        },
        SET_IS_MOBILE: (state, action) => {
            state.isMobile = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { TOGGLE_SIDEBAR_MENU, RESET, SET_IS_MOBILE } = CoreSlice.actions;

export default CoreSlice.reducer;
